module.exports = __webpack_public_path__ + "img/logo-ma.652b82f0.png";